import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Freight } from "../../interfaces/model/freight.interface";
import { Injectable } from "@angular/core";
import { FreightService } from "../../services/freight.service";
import { CalculateFreight, ClearFreight } from "./freight.action";
import { of, tap } from "rxjs";

export class FreightStateModel {
  data: Freight[] | null;
}

@State<FreightStateModel>({
  name: "freight",
  defaults: {
    data: null}})
@Injectable()
export class FreightState {
  constructor(private _freightService: FreightService) {}

  @Selector()
  static freight(state: FreightStateModel) {
    return state.data;
  }

  @Action(CalculateFreight)
  calculateFreight(
    ctx: StateContext<FreightStateModel>,
    action: CalculateFreight
  ) {
    const state = ctx.getState();
    state.data = null;
    return this._freightService.calculateFreight(action.request).pipe(
      tap((data) => {
        ctx.patchState({
          data});
      })
    );
  }

  @Action(ClearFreight)
  clearFreight(ctx: StateContext<FreightStateModel>) {
    ctx.patchState({
      data: null});
    return of();
  }
}
